import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { FindUsernameFormValues, findUsernameSchema } from "../../schema/auth/FindUsernameSchema"
import { zodResolver } from "@hookform/resolvers/zod"
import { Button, TextField, CircularProgress } from "@mui/material"
import { AuthBox, HorizontalLayout, MainContainer, VerticalLayout } from "../../common/common-layout"
import { useForm } from "react-hook-form"
import BTBox from "../../common/components/BTBox"
import theme from '../../common/theme';
import loginCi from "../../assets/icons/login_ci.svg"
import { TitleNormal } from "../../common/common-text"
import { requestFindUsernameEmail } from "../../service/AuthService"
import { dialogStore } from "../../store/DialogStore"
import BaseLayout from "../BaseLayout"

const FindUsername = () => {
    const navigate = useNavigate();
    const [error, setError] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);

    const {
        register,
        handleSubmit,
        formState: { errors },
        watch
    } = useForm<FindUsernameFormValues>({
        resolver: zodResolver(findUsernameSchema),
    });

    // 회원가입 처리 함수
    const handleFindUsername = async (data: FindUsernameFormValues) => {
        /// 모든 입력값이 유효할 떄만 진행
        if (Object.keys(errors).length > 0) {
            setError("입력Form 에러");
            return;
        }
        if (isSubmitting) return;           // ✅ 중복 클릭 방지

        try {
            setIsSubmitting(true);            // ✅ 시작
            const result = await requestFindUsernameEmail(data.email);
            if (result) {
                navigate("/find-username/result", { state: true }); // 성공 결과 표시
            } else {
                navigate("/find-username/result", { state: false }); // 실패 결과 표시
            }
        } catch (e) {
            console.error("handleFindUsername 호출 에러: ", e);
            dialogStore.showDialog({
                title: '알림',
                message: '서버 에러가 발생하였습니다.',
                onConfirm: () => {
                },
                onClose: () => {
                },
            });
        } finally {
            setIsSubmitting(false);           // ✅ 종료
        }
    };

    const handleMoveToLogin = () => {
        navigate("/login");
    };

    return (
        <BaseLayout>
            <MainContainer backgroundColor='#14B446'>
                <AuthBox style={{ width: '516px' }}>
                    <VerticalLayout>
                        <form onSubmit={handleSubmit(handleFindUsername)} style={{ width: 516 }}>
                            <BTBox height="20px" />
                            <HorizontalLayout style={{ justifyContent: 'center', width: '100%' }}>
                                <img src={loginCi} />
                            </HorizontalLayout>
                            <BTBox height='50px' />
                            <TitleNormal color='#8a92a6'>가입 이메일</TitleNormal>
                            <BTBox height='8px' />
                            <HorizontalLayout>
                                <TextField
                                    variant="outlined"
                                    fullWidth
                                    {...register("email")}
                                    error={!!errors.email}
                                    helperText={errors.email?.message}
                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            '& fieldset': {
                                                borderColor: errors.email ? '#c03221' : theme.colors.bbTech, // 원하는 색상
                                            },
                                            '&:hover fieldset': {
                                                borderColor: theme.colors.bbTech,
                                            },
                                            '&.Mui-focused fieldset': {
                                                borderColor: theme.colors.bbTech,
                                            },
                                        },
                                    }}
                                />
                            </HorizontalLayout>



                            {error && <p style={{ color: "red" }}>{error}</p>}

                            <BTBox height='30px' />
                            <Button
                                type="submit"
                                disabled={isSubmitting}                  // ✅ 비활성화
                                style={{
                                    width: '100%',
                                    height: '59px',
                                    fontSize: '20px',
                                    fontWeight: 700,
                                    backgroundColor: theme.colors.bbTech, // 원하는 색상
                                    color: '#fff',
                                    border: 'none',
                                    borderRadius: '10px',
                                    cursor: isSubmitting ? 'not-allowed' : 'pointer', // ✅ 커서
                                    outline: 'none',
                                    position: 'relative',                 // ✅ 스피너 오버레이용
                                }}
                            >
                                <span style={{ visibility: isSubmitting ? 'hidden' : 'visible' }}>
                                    아이디 찾기
                                </span>
                                {isSubmitting && (
                                    <CircularProgress
                                    size={24}
                                    sx={{ color: 'white', position: 'absolute', inset: 0, margin: 'auto' }}
                                    />
                                )}
                            </Button>
                            <BTBox height='30px' />
                        </form>
                        <HorizontalLayout style={{ justifyContent: 'center', width: '100%' }}>
                            <Button
                                type="button"
                                style={{
                                    background: 'none',
                                    border: 'none',
                                    padding: 0,
                                    margin: 0,
                                    fontSize: '16px',
                                    color: '#3A57E8',
                                    cursor: 'pointer',
                                    textDecoration: 'none',
                                    outline: 'none',
                                    textTransform: 'none',
                                    lineHeight: '1',
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    height: 'auto',
                                }}
                                onClick={handleMoveToLogin}
                            >
                                로그인으로 돌아가기
                            </Button>
                        </HorizontalLayout>
                        <BTBox height='20px' />
                    </VerticalLayout>
                </AuthBox>

            </MainContainer>
        </BaseLayout>
    );
};

export default FindUsername;